<div class="" id="favorite_devices">
    
    <div class="row">
        <div class="col-12 col-xl-12 stretch-card" *ngIf="favorite_devices.length == 0">
            <h3>No device favorite yet.</h3>
        </div>
    </div>
    <div class="favorite-device-group" *ngFor="let device_group of favorite_devices">
        <h4 class="favorite-device-type">{{ device_group.device_type }}</h4>
        <div class="row">
            <div class="col-12 col-xl-12 stretch-card">
                <div class="row flex-grow">
                    <div class="col col-lg-3 grid-margin stretch-card" *ngFor="let device of device_group.devices">
                        <div class="card">
                            <div class="card-body">
                                <div class="row m-0">
                                    <div class="col-12 p-0">
                                        <div class="favorite-device-header d-flex align-items-center justify-content-between mb-2">
                                            <h5 class="device_location mb-0"
                                                (click)="gotoDevice(device.device_id)">{{ device.location }}</h5>
                                            <span
                                                (click)="toggleFavorite(device.device_id)"
                                                class="d-flex float-right heart-fill favourite-icon"></span>
                                        </div>
                                        <div class="favorite-device-metric d-flex justify-content-between"
                                            *ngFor="let metric of getMetricKeys(device)">
                                            <span>{{ metric }}</span>
                                            <span>{{ device[metric] }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- row -->